/** Keep the existing first-input focus behaviour when a vertical is loaded lazily. */
export default function focusSearchControls(container: HTMLElement) {
  const initialFocus = document.activeElement
  const observer = new MutationObserver(focus)

  function focus() {
    // A child or the user has already moved focus; don't override that choice.
    if (document.activeElement !== initialFocus) {
      observer.disconnect()
      return
    }
    const fields = Array.from(container.querySelectorAll<HTMLElement>(
      'input[type="text"]:not([inputmode="none"]), textarea:not([inputmode="none"]), button',
    ))
    const enabledFields = fields.filter(field => field.getClientRects().length > 0 && !field.matches(':disabled, [aria-disabled="true"]'))
    const firstInput = enabledFields.find(field => field.matches('input, textarea')) ?? enabledFields[0]
    if (firstInput) {
      firstInput.focus()
      observer.disconnect()
    }
  }

  observer.observe(container, { childList: true, subtree: true })
  focus()
  return () => observer.disconnect()
}
